import React from 'react';
import { Login } from 'react-admin';

export const NotificationLoginPage = () => <Login backgroundImage={""} />;